var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _g, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFemaleInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27 54C12.0756 54 0 41.9064 0 27C0 12.0756 12.0936 0 27 0C41.9243 0 54 12.0936 54 27C54.0179 41.9243 41.9243 54 27 54Z",
    fill: "#F7C0B5"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8482_23957",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 54
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 54C12.0756 54 0 41.9064 0 27C0 12.0756 12.0936 0 27 0C41.9243 0 54 12.0936 54 27C54.0179 41.9243 41.9243 54 27 54Z",
    fill: "#F7C0B5"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8482_23957)"
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1925 49.7351C42.0665 49.8251 41.9225 49.9151 41.7965 50.0051C41.6525 50.0951 41.5265 50.1851 41.3825 50.2571C41.2565 50.3291 41.1485 50.4011 41.0225 50.4731C41.0045 50.4911 40.9865 50.4911 40.9685 50.5091C40.5545 50.7611 40.1225 50.9951 39.6905 51.2111C39.5645 51.2831 39.4205 51.3551 39.2945 51.4091C39.2945 51.4091 39.2765 51.4271 39.2585 51.4271C39.1145 51.4991 38.9705 51.5711 38.8265 51.6431C38.5385 51.7871 38.2325 51.9131 37.9445 52.0391C37.8005 52.1111 37.6385 52.1651 37.4945 52.2191C37.3505 52.2731 37.1885 52.3451 37.0445 52.3991C36.9005 52.4531 36.7385 52.5251 36.5945 52.5791C36.5945 52.5791 36.5945 52.5791 36.5765 52.5791C36.4325 52.6331 36.2705 52.6871 36.1265 52.7411C35.8025 52.8491 35.4605 52.9571 35.1365 53.0651C35.0285 53.1011 34.9025 53.1371 34.7945 53.1731C34.4525 53.2811 34.1105 53.3711 33.7685 53.4431C33.6425 53.4791 33.5165 53.4971 33.3725 53.5331C33.0485 53.6051 32.7065 53.6771 32.3825 53.7491C32.3105 53.7671 32.2565 53.7671 32.1845 53.7851C32.0765 53.8031 31.9505 53.8211 31.8425 53.8391C31.6805 53.8571 31.5365 53.8931 31.3745 53.9111C31.3025 53.9291 31.2305 53.9291 31.1585 53.9471C31.0685 53.9651 30.9605 53.9831 30.8525 53.9831C30.5645 54.0191 30.2585 54.0551 29.9705 54.0911C29.8805 54.1091 29.7725 54.1091 29.6825 54.1271H29.6645C29.5385 54.1451 29.4125 54.1451 29.2865 54.1631C29.1605 54.1811 29.0345 54.1811 28.9085 54.1811C28.8365 54.1811 28.7465 54.1991 28.6745 54.1991C28.5305 54.1991 28.4045 54.2171 28.2785 54.2171C28.0985 54.2171 27.9365 54.2351 27.7565 54.2351C27.5765 54.2351 27.4145 54.2351 27.2345 54.2351C27.1085 54.2351 26.9825 54.2351 26.8565 54.2351C19.2785 54.1271 12.4385 50.9051 7.57855 45.7931C7.57855 45.7931 7.57855 45.7751 7.56055 45.7751C8.11855 44.6771 10.1885 42.6971 12.3485 41.0591C15.0845 38.9891 18.9545 37.7111 18.9545 37.7111C18.9545 37.7111 21.4925 37.2971 30.9065 39.2591C38.0885 40.7711 41.1485 46.9091 42.1925 49.7351Z",
    fill: "#FEE4BF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.9047 44.2451C32.5267 46.0991 30.0787 47.1971 25.9567 45.5411C20.8987 43.4891 18.9547 37.7111 18.9547 37.7111C18.6847 33.5711 18.0547 30.0251 18.0547 30.0251C23.9047 29.5211 30.8167 36.3611 30.8167 36.3611L31.6087 39.7451C31.6807 40.0331 31.8247 40.2851 32.0407 40.4651C32.4187 41.1131 33.1567 43.0571 32.9047 44.2451Z",
    fill: "#FEE4BF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M32.0397 40.4831C28.6017 40.3031 26.0637 39.7991 23.3457 34.9211C25.6497 36.9551 28.3677 37.7291 31.2297 38.0891L31.6077 39.7451C31.6797 40.0511 31.8237 40.3031 32.0397 40.4831Z",
    fill: "#EFBDA5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M39.1505 18.7931C39.4745 20.3051 39.6365 21.5291 38.7545 25.5611C37.8725 29.5931 39.5645 33.6251 35.3165 37.3151C32.4545 39.7991 27.4505 40.2671 23.4545 37.5491C22.1045 36.6311 20.8625 35.3531 19.8545 33.6791C19.0625 32.3651 18.1445 31.1231 17.1185 29.9891C15.6965 28.4411 13.9865 25.3271 14.8325 19.8191C16.2005 10.8551 25.0745 9.82911 30.3125 10.8191C35.5505 11.8091 38.2685 14.7971 39.1505 18.7931Z",
    fill: "#FEE4BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9251 25.8311C21.9251 25.8311 21.3671 23.1311 18.7391 23.4551C16.4711 23.7431 15.6791 29.1791 20.8271 30.6911",
    fill: "#FEE4BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M20.665 28.2251C20.665 28.2251 20.017 27.8111 20.089 27.0911C20.197 26.2451 20.089 25.7231 19.693 25.5611C18.703 25.1471 18.505 26.2991 18.541 26.4431",
    stroke: "#423232",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3985 29.9711C34.3985 29.9711 35.0825 30.0071 35.7305 29.2331C36.0905 28.8011 36.3965 28.2611 36.1985 28.0991C36.0005 27.9191 32.7425 28.4231 32.5265 28.8551C32.3105 29.2871 33.5705 29.9711 34.3985 29.9711Z",
    fill: "#EFBDA5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9387 23.9231C34.9387 23.9231 34.9747 25.6331 36.0727 27.5411C36.5587 28.3871 35.8207 29.7731 34.2188 30.0071",
    stroke: "#423232",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M25.1821 30.8891C26.2061 30.8891 27.0361 30.2041 27.0361 29.3591C27.0361 28.5141 26.2061 27.8291 25.1821 27.8291C24.1582 27.8291 23.3281 28.5141 23.3281 29.3591C23.3281 30.2041 24.1582 30.8891 25.1821 30.8891Z",
    fill: "#F2A5B2"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.42,
    d: "M38.4662 27.8651C38.4122 28.8731 38.4302 29.8631 38.3582 30.8531C37.5662 30.6731 36.9902 30.0791 36.9902 29.3771C36.9902 28.6211 37.6202 28.0091 38.4662 27.8651Z",
    fill: "#F2A5B2"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4235 38.8798C32.4235 38.8798 29.7235 39.6718 25.9795 38.4478C22.2355 37.2238 18.5815 34.0018 18.5815 34.0018C18.5815 34.0018 17.3935 34.0198 16.9435 34.9198C16.5115 35.8198 16.5295 37.6738 15.8455 38.1778C15.6835 38.2858 15.2335 38.4118 14.5675 38.5918C13.4875 38.8978 11.8855 39.3658 10.2655 40.2838C9.05946 40.9678 7.83546 41.8858 6.80946 43.1458C6.34146 43.7218 5.92746 44.3698 5.56746 45.1078C2.72346 50.8858 3.94746 58.9858 3.94746 58.9858H47.9395C47.9395 58.9858 46.6615 48.9778 43.9075 45.6838C41.1535 42.3898 35.8975 39.7258 34.3495 39.0238V37.9798C34.3675 37.9798 33.4135 38.6098 32.4235 38.8798Z",
    fill: "#48D89E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_8482_23957",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 3,
    y: 34,
    width: 45,
    height: 25
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4235 38.8798C32.4235 38.8798 29.7235 39.6718 25.9795 38.4478C22.2355 37.2238 18.5815 34.0018 18.5815 34.0018C18.5815 34.0018 17.3935 34.0198 16.9435 34.9198C16.5115 35.8198 16.5295 37.6738 15.8455 38.1778C15.6835 38.2858 15.2335 38.4118 14.5675 38.5918C13.4875 38.8978 11.8855 39.3658 10.2655 40.2838C9.05946 40.9678 7.83546 41.8858 6.80946 43.1458C6.34146 43.7218 5.92746 44.3698 5.56746 45.1078C2.72346 50.8858 3.94746 58.9858 3.94746 58.9858H47.9395C47.9395 58.9858 46.6615 48.9778 43.9075 45.6838C41.1535 42.3898 35.8975 39.7258 34.3495 39.0238V37.9798C34.3675 37.9798 33.4135 38.6098 32.4235 38.8798Z",
    fill: "#48D89E"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_8482_23957)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.0408 45.7558C12.0946 45.7558 12.9488 44.9016 12.9488 43.8478C12.9488 42.7941 12.0946 41.9398 11.0408 41.9398C9.98705 41.9398 9.13281 42.7941 9.13281 43.8478C9.13281 44.9016 9.98705 45.7558 11.0408 45.7558Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8943 44.8738C22.9481 44.8738 23.8023 44.0196 23.8023 42.9658C23.8023 41.9121 22.9481 41.0578 21.8943 41.0578C20.8406 41.0578 19.9863 41.9121 19.9863 42.9658C19.9863 44.0196 20.8406 44.8738 21.8943 44.8738Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1033 40.8238C31.1571 40.8238 32.0113 39.9696 32.0113 38.9158C32.0113 37.8621 31.1571 37.0078 30.1033 37.0078C29.0496 37.0078 28.1953 37.8621 28.1953 38.9158C28.1953 39.9696 29.0496 40.8238 30.1033 40.8238Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5115 54.2158C19.5653 54.2158 20.4195 53.3616 20.4195 52.3078C20.4195 51.2541 19.5653 50.3998 18.5115 50.3998C17.4578 50.3998 16.6035 51.2541 16.6035 52.3078C16.6035 53.3616 17.4578 54.2158 18.5115 54.2158Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M40.7225 53.2438C41.7762 53.2438 42.6305 52.3896 42.6305 51.3358C42.6305 50.2821 41.7762 49.4278 40.7225 49.4278C39.6687 49.4278 38.8145 50.2821 38.8145 51.3358C38.8145 52.3896 39.6687 53.2438 40.7225 53.2438Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2107 51.6958C31.2645 51.6958 32.1187 50.8416 32.1187 49.7878C32.1187 48.7341 31.2645 47.8798 30.2107 47.8798C29.157 47.8798 28.3027 48.7341 28.3027 49.7878C28.3027 50.8416 29.157 51.6958 30.2107 51.6958Z",
    fill: "#FCED7E"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.2459 43.9558C40.2997 43.9558 41.1539 43.1016 41.1539 42.0478C41.1539 40.9941 40.2997 40.1398 39.2459 40.1398C38.1921 40.1398 37.3379 40.9941 37.3379 42.0478C37.3379 43.1016 38.1921 43.9558 39.2459 43.9558Z",
    fill: "#FCED7E"
  }))), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M34.3671 39.0238C34.3671 39.0238 34.6011 40.6438 34.1871 41.5618C33.5211 43.0738 28.8951 44.8018 23.2971 42.7858C18.8511 41.1838 16.6731 38.9698 16.6191 38.6278",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9862 35.8378C19.8962 35.9458 19.8062 36.0898 19.7342 36.2698C19.4822 36.8818 19.4102 38.1598 19.4102 38.1598",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0284 37.6918C22.9564 37.8358 22.8844 37.9978 22.8484 38.1778C22.7584 38.6458 22.6504 40.1218 22.6504 40.1218",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0871 38.9518C26.0511 39.0958 26.0151 39.2758 25.9971 39.4918C25.9611 39.7438 25.9791 41.2738 25.9791 41.2738",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M29.3633 39.6718C29.3993 40.0858 29.4173 40.6618 29.3633 41.3638",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M32.1172 39.5278C32.1712 39.8698 32.2252 40.3378 32.2432 40.9318",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M18.0248 34.0738C17.5928 34.2358 17.0168 34.6678 16.8008 35.9278",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M36.4912 40.0858C35.5732 39.5818 34.8172 39.2218 34.3672 39.0238V37.9798",
    stroke: "#329369",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.9779 21.8719C31.3689 21.9259 31.6711 21.5119 31.5289 21.1159C31.4578 20.8999 31.3334 20.7019 31.1379 20.5759C30.5335 20.1979 28.2761 20.1619 27.0852 21.0259C26.0364 21.8179 29.2004 21.6199 30.9779 21.8719Z",
    fill: "#423232"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M35.9027 22.0699C35.5827 22.0699 35.3872 21.6559 35.5472 21.3139C35.6361 21.1339 35.7605 20.9719 35.9382 20.8819C36.4893 20.6119 37.9646 20.7739 38.6223 21.6919C39.2088 22.5019 37.378 22.0519 35.9027 22.0699Z",
    fill: "#423232"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M30.3567 24.1399C29.2191 23.5639 27.4238 23.9959 27.4238 23.9959",
    stroke: "#423232",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3775 24.4999C37.3775 24.4999 36.9154 23.9959 35.209 24.3919",
    stroke: "#423232",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M35.7242 32.6038C35.1021 32.8775 34.8035 32.3301 33.8331 32.8029C33.1363 33.1264 32.7631 33.2259 31.917 32.7282C31.3696 32.3799 30.6978 32.8775 30.0508 31.932",
    stroke: "#423232",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M43.7179 38.8421C42.7099 36.6101 41.9359 36.9161 42.6379 34.9001C43.3399 32.9021 42.4399 31.4801 40.5859 29.5901C38.8219 27.7901 38.6419 25.8281 38.6959 25.5401C38.5339 26.2961 38.4619 27.0701 38.4259 27.8261C38.3719 28.8341 38.3899 29.8241 38.3179 30.8141C38.1739 33.0281 37.6519 35.2061 35.2759 37.2581C34.2319 38.1581 32.8999 38.8061 31.4239 39.1121C31.0279 40.3181 31.6219 41.1821 32.9179 41.3261C34.2139 41.4701 34.7539 43.4141 37.6879 44.3321C42.0799 45.7541 44.7259 41.0741 43.7179 38.8421Z",
    fill: "#423232"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5095 17.0621C35.8875 17.2601 36.2115 17.0801 36.4095 16.6841C38.4975 16.3601 38.9835 20.5361 39.0555 20.7881C39.1275 21.0581 39.1635 21.8141 39.0195 23.8841C38.9295 25.0361 45.6255 16.8641 39.5055 13.4081C39.9555 12.7421 39.6315 9.43011 35.8695 8.62011C34.5195 8.33211 32.7555 9.59211 30.5415 9.10611C21.8835 7.18011 12.9015 9.01611 13.6035 20.4461C13.7655 22.9481 13.9275 25.6481 9.67951 27.4481C4.74751 29.5361 4.99951 34.9901 8.47351 36.1061C9.91351 36.5741 5.16151 39.8141 7.93351 42.6941C9.37351 44.2061 11.9475 41.1461 14.5575 42.8021C18.4995 45.3041 20.4615 44.1701 21.2355 43.1801C22.8195 41.1641 20.8575 37.1141 20.8575 37.1141C20.8575 37.1141 21.6315 35.8721 21.8835 35.2061C23.1075 31.9301 20.1915 30.4541 20.1915 30.4541C15.6915 28.7261 16.5015 23.7041 18.6975 23.4161C21.0015 23.1281 21.7215 25.1801 21.8475 25.6841C21.8475 25.6841 23.8815 28.4921 27.8055 22.0841C31.6935 15.6761 33.8175 16.1441 35.5095 17.0621Z",
    fill: "#423232"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4219 29.3039V32.3639",
    stroke: "#FFDE55",
    strokeWidth: 0.746507,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M21.8513 36.4679C21.3653 36.9539 20.6993 37.2599 19.9433 37.2599C18.4853 37.2599 17.2793 36.0719 17.2793 34.5959C17.2793 33.1379 18.4673 31.9319 19.9433 31.9319C20.6813 31.9319 21.3653 32.2379 21.8513 32.7239C21.5273 32.5439 21.1673 32.4359 20.7713 32.4359C19.5833 32.4359 18.6113 33.4079 18.6113 34.5959C18.6113 35.7839 19.5833 36.7559 20.7713 36.7559C21.1673 36.7739 21.5273 36.6659 21.8513 36.4679Z",
    fill: "#FFDE55"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M19.4214 35.6759C20.0079 35.6759 20.4834 35.2004 20.4834 34.6139C20.4834 34.0274 20.0079 33.5519 19.4214 33.5519C18.8349 33.5519 18.3594 34.0274 18.3594 34.6139C18.3594 35.2004 18.8349 35.6759 19.4214 35.6759Z",
    fill: "#FF6B57"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M39.9599 32.7599C39.6359 32.5799 39.2759 32.4719 38.8799 32.4719C38.5919 32.4719 38.3399 32.5259 38.0879 32.6339C38.1239 32.4179 38.1779 32.2019 38.1959 31.9859C38.8979 32.0039 39.5099 32.2919 39.9599 32.7599Z",
    fill: "#FFDE55"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M39.977 36.4679C39.491 36.9539 38.825 37.2599 38.069 37.2599C37.313 37.2599 36.611 36.9359 36.125 36.4139C36.413 36.0899 36.665 35.7659 36.899 35.4419C37.223 36.2159 37.997 36.7379 38.879 36.7379C39.275 36.7739 39.653 36.6659 39.977 36.4679Z",
    fill: "#FFDE55"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M38.608 34.6139C38.608 35.2079 38.14 35.6759 37.546 35.6759C37.312 35.6759 37.096 35.6039 36.916 35.4599C37.33 34.8479 37.636 34.2179 37.834 33.6059C38.266 33.7139 38.608 34.1279 38.608 34.6139Z",
    fill: "#FF6B57"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "color"
    }
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 27,
    cy: 27,
    r: 27,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFemaleInactive);
export default __webpack_public_path__ + "static/media/female-inactive.429b280188f110af56a94e8a9a1b8da6.svg";
export { ForwardRef as ReactComponent };